import { render, staticRenderFns } from "./UpdateUserBusinessCard.vue?vue&type=template&id=612edf95&"
import script from "./UpdateUserBusinessCard.vue?vue&type=script&lang=js&"
export * from "./UpdateUserBusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserBusinessCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports